/**
 * Returns an array of [firstName, lastName] extracted from the fullName, optionally
 * filling the lastName if the fullName has only one part.
 *
 * @param {String} fullName - The full name of the user to extract parts from.
 * @param {Boolean} fill - Whether to fill the lastName with the firstName when empty
 * @returns {[String, String]} firstName and lastName
 */
export default function fullNameParts(fullName, fill = true) {
  const firstName = fullName.split(' ')[0];
  const lastName = fullName.split(' ').slice(1).join(' ');

  return [
    firstName,
    lastName || (fill ? firstName : lastName)
  ];
}
